'use strict';

function SideNavigation() {
  // Add a skip link to skip the side nav
  $('#block-side-navigation, #block-mobile-menu').before('<a href="#main-content" class="visually-hidden focusable skip-link">Skip to main content</a>') // Add the link used to expand menu for parent LI
  ;
  $('#block-side-navigation > .menu > .menu-item--expanded > a').after('<a class="expand" aria-expanded="false" aria-label="Toggle sub-navigation" href="#expand"><i class="icon-chevron-down"></i></a>'); // Generic accordion trigger to expand the immediate child UL after it

  $('#block-mobile-menu > .menu > .menu-item--expanded > a').after('<a class="expand" aria-expanded="false" aria-label="Toggle sub-navigation" href="#expand"><i class="icon-chevron-down"></i></a>');
  $('body').on('click', '.expand', function ($event) {
    $event.preventDefault();
    $('.expand').attr('aria-expanded', 'false');
    if ($(this).hasClass('active')) {
      $(this).siblings('ul').removeClass('show');
      $(this).siblings('.level-1').removeClass('show');
      $(this).removeClass('active');
      $(this).attr('aria-expanded', 'false');
    } else {
      $(this).addClass('active');
      $(this).siblings('ul').addClass('show');
      $(this).siblings('.level-1').addClass('show');
      $(this).attr('aria-expanded', 'true');
    }
  }); // For the active link show all the parents and immediate child

  $('#block-side-navigation a.is-active, #block-mobile-menu a.is-active').parents('ul').addClass('show');
  $('#block-side-navigation a.is-active, #block-mobile-menu a.is-active').parents('ul').siblings('.expand').addClass('active').attr('aria-expanded', 'true');
  $('#block-side-navigation a.is-active, #block-mobile-menu a.is-active').siblings('ul').addClass('show');
  $('#block-side-navigation a.is-active, #block-mobile-menu a.is-active').siblings('.expand').addClass('active').attr('aria-expanded', 'true');
};
export default SideNavigation;
